import { create } from 'zustand';

type MegaMenuStoreState = {
  menuIsOpen: boolean;
  openMenu?: string;
  close(): void;
  open(menu: string): void;
};

export const useMegaMenuStore = create<MegaMenuStoreState>((set) => ({
  menuIsOpen: false,
  close: () => set({ openMenu: undefined, menuIsOpen: false }),
  open: (menu) =>
    set({
      openMenu: menu,
      menuIsOpen: true,
    }),
}));
